import './SourcePreview.css';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlBadge from '@shoelace-style/shoelace/dist/react/badge/index.js';
import SlCard from '@shoelace-style/shoelace/dist/react/card/index.js';
import { CDSUiIcons } from '@cencora-design-system/assets/icons';

export default function SourcePreview({ record, isPreviewLoading, setIsPreviewClicked, isPreviewError }) {

    const title = record?.title || record?.sourceTitle?.[0] || 'No title available';
    const categories = record?.category || (record?.category ? [record.category] : []);
    const region = record?.region;
    const sourceUrl = record?.sourceUrl || record?.url;
    const summary = record?.llmSummary || 'No summary is available for this record.';

    const scrapedText = record?.scrapedDate
        ? new Date(record.scrapedDate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })
        : null;

    const publishedText = record?.publishedDate
        ? new Date(record.publishedDate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })
        : null;

    if (isPreviewLoading && !isPreviewError) {
        return <div className="source-preview-container">
            <div className="source-preview-loading">Preview loading...</div>
        </div>;
    }
    if (isPreviewError) {
        return <div className="source-preview-container">
            <div className="source-preview-error">Preview failed to load, try again.</div>
        </div>;
    }

    return (
        <>
        <div className="source-preview-header">
            Preview
        </div>
        <SlCard>
        <div className="source-preview-container">
            <div className="source-preview-card">
                <div className="source-preview-section-heading">
                    <div className="source-preview-row">
                        <div className="source-preview-row-left">
                            <div className="source-preview-badges">
                                {categories.map((category, index) => (
                                    <SlBadge key={index} className="source-preview-badge" size="medium" pill>
                                        {category}
                                    </SlBadge>
                                ))}
                                {region && (
                                    <SlBadge className="source-preview-badge" size="medium" pill>
                                        <span className="source-preview-region-content">
                                            <SlIcon 
                                                src={CDSUiIcons.IconPin}
                                                label="Location"
                                            />
                                            <span>{region}</span>
                                        </span>
                                    </SlBadge>
                                )}
                            </div>
                        </div>
                    </div>

                    {title && (
                        <div className="source-preview-title">
                            {title}
                        </div>
                    )}

                    <div className="source-preview-row">
                        <div className="source-preview-row-left">
                            {sourceUrl && (
                                <span><SlIcon src="/Icons/UrlIcon.svg" /><a href={sourceUrl} target="_blank" rel="noreferrer">{sourceUrl}</a></span>
                            )}
                            {scrapedText && (
                                <span><SlIcon src="/Icons/scrape_time.svg" />Scraped: {scrapedText}</span>
                            )}
                            {publishedText ? (
                                <span><SlIcon src={CDSUiIcons.IconCalendar} />Published: {publishedText}</span>
                            ) : (
                                <span><SlIcon src={CDSUiIcons.IconCalendar} />Published: N/A</span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="source-preview-summary-section">
                    <div className="source-preview-summary-heading">
                        Summary <span>(AI Generated)</span>
                    </div>
                    <div className="source-preview-summary-content">
                        <p>{summary}</p>
                    </div>
                </div>
            </div>
        </div>
        </SlCard>
        </>
    );
}